import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';

export const styles = css`
  :host {
    display: block;
  }

  .form-row {
    position: relative;
    transition: 1s;
  }

  label {
    position: absolute;
    color: var(--label-color, #a9acb1);
    font-size: ${pxToRem(16)};
    -webkit-transform: translateY(24px);
    transform: translateY(${pxToRem(24)});
    transform-origin: top left;
    cursor: text;
    transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  .filled {
    -webkit-transform: translateY(-${pxToRem(0)}) scale(0.85);
    transform: translateY(-${pxToRem(0)}) scale(0.8);
  }

  input {
    box-sizing: border-box;
    width: 100%;
    margin-top: 0;
    padding-top: ${pxToRem(24)};
    padding-right: ${pxToRem(20)};
    padding-bottom: ${pxToRem(15)};
    height: ${pxToRem(60)};
    color: var(--color, #484e5c);
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(16)};
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--border-bottom-color, #a9acb1);
    border-radius: 0;
    outline: none;
  }

  .input-clear {
    display: none;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -${pxToRem(9)};
  }

  .input-clear.show {
    display: block;
  }

  .clear-icon {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
    background-color: transparent;
    cursor: pointer;
  }

  .input-wrap {
    position: relative;
  }

  .focus-border {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: ${pxToRem(2)};
    background-color: #444b5b;
    transition: 0.3s;
  }

  input:focus ~ .focus-border {
    width: 100%;
  }

  .form__message {
    position: relative;
    display: none;
    width: 100%;
    color: #e6615e;
    text-align: left;
  }

  .error .form__input {
    --border-bottom-color: #e6615e;
  }
  .error .form__message {
    display: block;
  }

  .form__message {
    margin-top: ${pxToRem(8)};
    font-size: ${pxToRem(11)};
  }
`;
